import script from "./orderRow.vue?vue&type=script&setup=true&lang=js"
export * from "./orderRow.vue?vue&type=script&setup=true&lang=js"

import "./orderRow.vue?vue&type=style&index=0&id=2e51b05e&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e51b05e"]])

export default __exports__